export default __webpack_public_path__ + "media/40-49.ed3c674d.svg";